import { logoutRequest } from '@/services/api/auth/AuthRequestService'
import { getLoginModuleData } from '@/services/api/module/ModuleService'
import axios from 'axios'

/**
 * @description
 * Remove user data of local storage and call mutation authLogout (set user token to '')
 *
 * @param {object} commit
 * @return {void}
 */
const loginActions = ({ commit }, response) => {
    console.log({ commit })
    localStorage.setItem('user', JSON.stringify(response.data.user))
    localStorage.setItem('user-token', response.data.user_token)
    if (response.data.permissions && response.data.permissions.length)
        localStorage.setItem(
            'permissions',
            JSON.stringify(response.data.permissions)
        )
    // reload main page without token
    let mainPageWithoutParams = window.location.href.split('?')[0] // same page without params
    window.location = mainPageWithoutParams
}

/**
 * @description
 * Call logout request and delete user data if backend response is successed
 *
 * @param {Object} commit
 * @return {Promise} server response of request
 */
const logoutRequestAction = ({ commit }) => {
    return new Promise((resolve, reject) => {
        logoutRequest()
            .then(response => {
                logoutActions({ commit })
                resolve(response)
            })
            .catch(err => {
                logoutActions({ commit })
                reject(err)
            })
    })
}

const goToMenu = async () => {
    let res = await getLoginModuleData()
    deleteStorageData()
    let url = res.data.g_login_module.url_module
    window.location.assign(url)
}

const deleteStorageData = () => {
    localStorage.removeItem('user')
    localStorage.removeItem('user-token')
    localStorage.removeItem('cash_desk_token')
    localStorage.removeItem('cash_desk_id')
    localStorage.removeItem('permissions')
}

/**
 * @description
 * Remove user data of local storage and call mutation authLogout (set user token to '')
 *
 * @param {object} commit
 * @return {void}
 */
const logoutActions = ({ commit }) => {
    commit('authLogout')
    deleteStorageData()
    // localStorage.removeItem('user')
    // localStorage.removeItem('user-token')
    delete axios.defaults.headers.common['Authorization']
}

export default {
    loginActions,
    logoutRequestAction,
    logoutActions,
    goToMenu,
}
